/**
 * Client helper for hitting the Bougie API from the browser or server.
 * Designed to be called from form actions or client components.
 */

export interface LeadInput {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  source?: string;
  persona?: "all-female" | "all-male" | "mixed" | "private";
  tripInterest?: string;
  /** Free-form inquiry message. Written as an HL contact note, not a tag. */
  note?: string;
  locale?: "es" | "en";
  tags?: string[];
  workflow?: string;
  attribution?: {
    sessionSource?: string;
    medium?: string;
    campaign?: string;
    referrer?: string;
    url?: string;
  };
}

export type LeadResult =
  | { ok: true; new: boolean; contactId: string }
  | { ok: false; error: string; issues?: unknown };

const API_BASE = import.meta.env.VITE_API_BASE ?? "http://localhost:8787";

export async function submitLead(input: LeadInput): Promise<LeadResult> {
  const res = await fetch(`${API_BASE}/lead`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  return (await res.json()) as LeadResult;
}
